import React from 'react';
import PropTypes from 'prop-types';
import Label from '../Label/Label.jsx';
import {colors} from '../../utils/colors.js';

const VARIANT_MAP = {
  CONFIRMED: 'success',
  CANCELLED: 'danger',
  TENTATIVE: 'warning',
};

const ReservationStatusLabel = ({status}) => {
  const variant = VARIANT_MAP[status];

  if (variant) {
    return (
      <Label variant={variant}>
        {status}
      </Label>
    );
  }

  return (
    <Label backgroundColor={colors.grey20} color={colors.grey}>
      {status}
    </Label>
  );
};

ReservationStatusLabel.propTypes = {
  status: PropTypes.string,
};

export default ReservationStatusLabel;
